<template>
    <div class="footer-form__wrapper">
        <div class="footer-form">
            <div class="footer-form__success" v-if="success">
                <p class="third-text-sb">Спасибо! На указанный email вы получите промокод на скидку.</p>
            </div>
            <div class="footer-form__success" v-else-if="alreadySubscribed">
                <p class="third-text-sb">Пользователь с таким email уже подписан.</p>
            </div>
            <div class="footer-form__main-content" v-else>
                <div>
                    <p class="footer-form__header third-text-sb">
                        Первая&nbsp;покупка ещё&nbsp;приятнее<br>со&nbsp;скидкой 500&nbsp;₽!
                    </p>
                    <p class="footer-form__under-header">Подпишитесь на&nbsp;рассылку,<br>чтобы получить промокод</p>
                </div>
                <form @submit.prevent="submit">
                    <div class="footer-form__input-box">
                        <input name="email" type="email" placeholder="Ваш email" required v-model="email"
                            :disabled="pending">
                        <button type="submit" class="footer-form__submit ignore-placeholder" :disabled="pending">
                            <span class="spinner" v-if="pending"></span>
                            <span class="arrow" v-else></span>
                        </button>
                    </div>
                    <p class="footer-form__consent">
                        <ConsentCheckbox v-model="consent" required />
                        <span class="text">
                            Подписываясь на&nbsp;рассылку,
                            вы подтверждаете свое&nbsp;согласие
                            <span style="white-space: nowrap;">с <a
                                    href="/terms-of-use">Условиями&nbsp;пользования</a></span>
                            <span style="white-space: nowrap;">и <a
                                    href="/politics">Политикой&nbsp;конфиденциальности</a></span>
                            и&nbsp;даёте согласие на&nbsp;получение рекламной рассылки
                        </span>
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { showInfoLabel } from '../infoLabel';
import { setCookie } from '../cookies';
import ConsentCheckbox from './consentCheckbox.vue';

const email = ref('');
const consent = ref(false);
const pending = ref(false);
const success = ref(false);
const alreadySubscribed = ref(false);

function setSubscribedCookie() {
    setCookie('catalogPopupHandled', 1, {
        expires: 31536000
    })
}

function submit(event) {
    pending.value = true;
    axios.post('/subscription/add', {
        email: email.value,
        consent: consent.value,
        from_funnel: true
    }).then(response => {
        const data = response.data;
        if (!data.subscribed) {
            alreadySubscribed.value = true;
        } else {
            success.value = true;
        }
        setSubscribedCookie();
    }).catch((error) => {
        showInfoLabel('Что-то пошло не так');
        console.error(error);
    }).finally(() => {
        pending.value = false;
    });
}

</script>
